import type { ExternalProviderUserInfo } from 'vince-core/types/auth';

// TODO externalize?
interface ClientConfig {
    clientId: string;
    url?: string;
}

interface ResolvedClientConfig extends ClientConfig {
    url: string;
}

// The OAuth `state` payload round-tripped through the Microsoft popup, and the message it
// posts back to the opener - shared between the composable that opens the popup and the
// redirect page that completes the exchange inside it.
export interface MicrosoftAuthState {
    nonce: string;
    v: string;
    o: string;
}

export interface MicrosoftPopupResult {
    nonce?: string;
    accessToken?: string;
    expiresIn?: number;
    userInfo?: ExternalProviderUserInfo;
    error?: string;
    error_description?: string;
}

export const MICROSOFT_CLIENT_ID = '74817bb1-3881-4c86-8652-22192d3599ca';
export const MICROSOFT_AUTHORIZE_ENDPOINT = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';
export const MICROSOFT_TOKEN_ENDPOINT = 'https://login.microsoftonline.com/common/oauth2/v2.0/token';
export const MICROSOFT_GRAPH_ME_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';
export const MICROSOFT_GRAPH_SCOPE = 'openid profile offline_access User.Read';
export const MICROSOFT_POPUP_TIMEOUT_MS = 5 * 60 * 1000;

const CLIENT_CONFIGS = {
    local: {
        clientId: MICROSOFT_CLIENT_ID,
        url: 'http://localhost:3000'
    },
    dev: {
        clientId: MICROSOFT_CLIENT_ID,
        url: 'https://dev.vincelive.dev'
    },
    staging: {
        clientId: MICROSOFT_CLIENT_ID,
        url: 'https://staging.vincelive.dev'
    },
    prod: {
        clientId: MICROSOFT_CLIENT_ID,
        url: 'https://vince.live'
    }
} as Record<string, ClientConfig>;

const DEFAULT_CLIENT_CONFIG = CLIENT_CONFIGS.local!;

const removeTrailingSlash = (value: string) => value.replace(/\/$/, '');

export const getAppBaseUrl = (fallbackUrl?: string) => {
    const configuredBaseUrl = fallbackUrl || '';

    if (configuredBaseUrl) {
        return removeTrailingSlash(configuredBaseUrl);
    }

    return import.meta.client ? window.location.origin : '';
};

export const getClientConfig = (): ResolvedClientConfig => {
    const config = useRuntimeConfig();
    console.debug('getClientConfig()', config);
    const environmentName = config.public.environment as string || 'local';
    const clientConfig = CLIENT_CONFIGS[environmentName] ?? DEFAULT_CLIENT_CONFIG;

    return {
        ...clientConfig,
        url: getAppBaseUrl(clientConfig.url)
    };
};

export const ROOT_FOLDER_ID = 'root';

export const MICROSOFT_GRAPH_DOWNLOAD_URL_FIELD = '@microsoft.graph.downloadUrl';

export const EXCLUDED_SITES_NAMES = ['appcatalog', 'community', 'hub'];
